
import styles from "./PartSurveyUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";
import PartSurveyItemUsed from './components/PartSurveyItemUsed';
import PartSurveyItemUse from './components/PartSurveyItemUse';
import { getSurveyUserDetailData, StartSurveyUser, getSurveyUser } from "service/SurveyService";
import { useLocation, useNavigate } from 'react-router-dom'
import userInfo from "utils/userInfo";
import { Button, Layout } from "components";
import moment from 'moment';
import Moment from 'react-moment'
import Notification from "utils/Notifications";

const PartSurveyUsed = () => {
  const { t } = useTranslation('common')

  const user = userInfo();
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [usedata, setData2] = useState([]);

  const navigate = useNavigate()
  const location = useLocation()
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const StartSurveyOn = async (event) => {
    event.preventDefault();
    try {
      const response = await StartSurveyUser(id);
      setData2(response.data)
      setNotify({
        isOpen: true,
        message: "Анкетирование успешно начат!",
        type: "success",
      });

      setRender(render)


    } catch (error) {
      setNotify({
        isOpen: true,
        message: "Ошибка при запуске, попробуйте позже!",
        type: "error",
      });
    }
  }
  const getData = async (id) => {
    try {
      let response = await getSurveyUserDetailData(id, data);
      let response_user_data = await getSurveyUser(id, data);

      setData(response.data);
      setData2(response_user_data.data)
      
    } catch (error) {
    }
  };
  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/tests");
    }


  }, [render, location.pathname, location.state]);

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <Layout>
      <div className={styles.test_card}>
        <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
          <div className={styles["test-app"]}>
            <h2>{data.title}</h2>
            <Button
              className={styles.open_btn}
              onClick={() => navigate('/surveys/')}
            >
              Вернуться
            </Button>
          </div>
          <div className={styles.defendant_header_selections}>
            <div>
              <h4>Дата создания анкетирования: {formatDate(data.createdAt)}</h4>
              <h4>Сегодня: <Moment format="DD MMMM YYYY" interval={1000} /> <Moment format="HH:mm:ss" interval={1000} /></h4>
              {(usedata?.status_info === "Начат") ?
                <h4>Вопросов: {data?.part_survey?.filter(item => item.type_defendant !== "infoText").length || 0}</h4> : ""}
             </div>
            <div>
              <h4>{user.surName} {user.firstName}</h4>
              <h4>Статус: {usedata?.status_info ? usedata?.status_info : "Не начат"}</h4>
              {(usedata?.status_info === "Завершен") ?
                <>
                  <h4>Дата/Время начала: {formatDate(usedata?.createdAt)}</h4>
                  <h4>Дана/Время завершения: {formatDate(usedata?.endAt)}</h4>
                  <h4>Потрачено времени: {usedata?.time_response}</h4>
                  <h4>Пройдено вопросов: {usedata?.working_info}</h4>

                </>
                : ((usedata?.status_info === "Начат") ? <><h4>Дата/Время начала: {usedata?.createdAt}</h4></> : "")}
            </div>
          </div>
        </div>
        {(usedata?.status_info !== "Начат" && usedata?.status_info !== "Завершен") ?
          <>
            <div className={styles.defendant_card_selection_header}>

              <h2>Вопросов: {data?.part_survey?.filter(item => item.type_defendant !== "infoText").length || 0}</h2>

            </div>
            <div className={styles.defendant_card_selection_footer}>


              <button
                className={styles.start_btn}
                onClick={StartSurveyOn}
              >
                {t('auto.usedcomponents_partsurveyused.k1')}
              </button>


            </div>
          </> : ''}
        {(usedata?.status_info === "Начат") &&
          <>
            {data?.part_survey?.map((item, index) =>
              <PartSurveyItemUsed
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}

                index={index}

                setRender={setRender}
              />


            )}

          </>

        }
        {(usedata?.status_info === "Завершен") &&
          <>
            {data?.part_survey?.map((item, index) =>
              <PartSurveyItemUse
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}
                item_selected_data={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id)  
                }
                index={index}

                setRender={setRender}
              />


            )}
          </>
        }
      </div >
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  );
};

export default PartSurveyUsed;
